import React from "react";
import {Box, Text} from "@chakra-ui/react";

/** TimeBox's single navigation accent (matches .toolbar-slider in myjira.css) — reused here so the
 * ported toolbar reads as part of the app instead of a foreign widget with its own color language. */
export const BRAND_ACCENT = "#ec8e00";

type InfoBarTone = "context" | "warning";

interface InfoBarProps {
    tone?: InfoBarTone;
    children: React.ReactNode;
}

/** Single, neutral context/warning banner style shared by every WeekActions dialog. */
export function InfoBar({tone = "context", children}: InfoBarProps) {
    if (tone === "warning") {
        return (
            <Box bg="orange.50" borderLeft="3px solid" borderColor="orange.400" borderRadius="md" p={3} mb={3} fontSize="sm">
                {children}
            </Box>
        );
    }
    return (
        <Box bg="gray.50" borderLeft="3px solid" borderColor={BRAND_ACCENT} borderRadius="md" p={3} mb={3} fontSize="sm">
            {children}
        </Box>
    );
}

/** The AD NL / OSM absence-booking notice, shown verbatim in both Settings and Help. */
export function HolidayNotice() {
    return (
        <InfoBar tone="warning">
            <Text fontWeight={700} color="orange.800">For AD NL: do not register vacation in TimeBox</Text>
            <Text color="orange.900">
                Automatic holiday filling is disabled. All absence hours are booked in AllSolutions only.
                For OSM in Germany/USA please use NBP-14 to book absence hours.
            </Text>
        </InfoBar>
    );
}
